<template>
    <div class="grid-content"><slot></slot></div>
</template>

<style lang="sass" scoped>
$grey-color: #efefef
$border-color: darken($grey-color, 7%)

.grid-content
    font-size: 0.9rem
    border-left: 1px solid $border-color
    margin-left: -1px
    width: 100%
</style>


<script>
export default { }
</script>
